var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 610,
    viewBox: "0 0 362 610",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_570_1256)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 362,
    height: 610,
    fill: "url(#paint0_linear_570_1256)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.213,
    cy: 48.6475,
    r: 12.8309,
    transform: "rotate(75.421 133.213 48.6475)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.14562,
    cy: 119.409,
    r: 12.8309,
    transform: "rotate(-134.896 6.14562 119.409)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.296,
    cy: 53.3452,
    r: 9.94688,
    transform: "rotate(75.421 123.296 53.3452)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.512,
    cy: 117.632,
    r: 9.94688,
    transform: "rotate(-134.896 16.512 117.632)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.464,
    cy: 92.8254,
    r: 2.37131,
    transform: "rotate(75.421 112.464 92.8254)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.912,
    cy: 143.63,
    r: 1.77848,
    transform: "rotate(75.421 107.912 143.63)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.955,
    cy: 90.3375,
    r: 2.96413,
    transform: "rotate(75.421 147.955 90.3375)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.56,
    cy: 125.873,
    r: 3.55696,
    transform: "rotate(75.421 145.56 125.873)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.082,
    cy: 93.7223,
    r: 10.8218,
    transform: "rotate(-178.603 244.082 93.7223)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.0005,
    cy: 178,
    r: 50.2049,
    transform: "rotate(135 69.0005 178)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294,
    cy: 178,
    r: 50.2049,
    transform: "rotate(135 294 178)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342,
    cy: 178,
    r: 50.2049,
    transform: "rotate(135 342 178)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 178,
    r: 50.2049,
    transform: "rotate(135 181 178)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.0005,
    cy: 178,
    r: 50.2049,
    transform: "rotate(135 20.0005 178)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 178,
    r: 50.2049,
    transform: "rotate(135 119 178)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235,
    cy: 178,
    r: 50.2049,
    transform: "rotate(135 235 178)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 104,
    r: 30.4059,
    transform: "rotate(135 321 104)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0005,
    cy: 118,
    r: 30.4059,
    transform: "rotate(135 46.0005 118)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 84.5,
    r: 21.5671,
    transform: "rotate(135 111 84.5)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 76,
    r: 21.5671,
    transform: "rotate(135 204.5 76)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 135,
    r: 26.8704,
    transform: "rotate(135 192 135)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.575,
    cy: 84.5922,
    r: 8.38937,
    transform: "rotate(-178.603 242.575 84.5922)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.457,
    cy: 125.75,
    r: 11.2116,
    transform: "rotate(141.649 323.457 125.75)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2372,
    cy: 117.897,
    r: 2.49816,
    transform: "rotate(-118.531 28.2372 117.897)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.1583,
    cy: 99.7286,
    r: 1.11029,
    transform: "rotate(-118.531 40.1583 99.7286)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.4913,
    cy: 76.1285,
    r: 0.832718,
    transform: "rotate(-118.531 36.4913 76.1285)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.312,
    cy: 104.868,
    r: 1.38786,
    transform: "rotate(-118.531 24.312 104.868)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.3884,
    cy: 88.4445,
    r: 1.66544,
    transform: "rotate(-118.531 21.3884 88.4445)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.8081,
    cy: 93.1199,
    r: 2.49816,
    transform: "rotate(-91.9848 71.8081 93.1199)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5929,
    cy: 82.1918,
    r: 1.11029,
    transform: "rotate(-91.9848 90.5929 82.1918)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.8598,
    cy: 59.4436,
    r: 0.832718,
    transform: "rotate(-91.9848 97.8598 59.4436)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.1205,
    cy: 79.7094,
    r: 1.38786,
    transform: "rotate(-91.9848 74.1205 79.7094)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.8436,
    cy: 63.7115,
    r: 1.66544,
    transform: "rotate(-91.9848 78.8436 63.7115)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.248,
    cy: 100.272,
    r: 2.49816,
    transform: "rotate(-147.406 299.248 100.272)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.913,
    cy: 78.6032,
    r: 1.11029,
    transform: "rotate(-147.406 300.913 78.6032)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.306,
    cy: 59.7092,
    r: 0.832718,
    transform: "rotate(-147.406 286.306 59.7092)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.519,
    cy: 90.755,
    r: 1.38786,
    transform: "rotate(-147.406 289.519 90.755)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.029,
    cy: 77.7896,
    r: 1.66544,
    transform: "rotate(-147.406 279.029 77.7896)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.3093,
    cy: 82.7484,
    r: 2.62669,
    transform: "rotate(-12.4538 50.3093 82.7484)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.1959,
    cy: 100.084,
    r: 1.16742,
    transform: "rotate(-12.4538 65.1959 100.084)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.1063,
    cy: 103.252,
    r: 0.875564,
    transform: "rotate(-12.4538 90.1063 103.252)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.619,
    cy: 82.579,
    r: 1.45927,
    transform: "rotate(-12.4538 64.619 82.579)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.0592,
    cy: 84.4065,
    r: 1.75113,
    transform: "rotate(-12.4538 82.0592 84.4065)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.229,
    cy: 59.4575,
    r: 4.5,
    transform: "rotate(72.8774 345.229 59.4575)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.705,
    cy: 87.2932,
    r: 2,
    transform: "rotate(72.8774 317.705 87.2932)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.772,
    cy: 130.27,
    r: 1.5,
    transform: "rotate(72.8774 315.772 130.27)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.517,
    cy: 83.8674,
    r: 2.5,
    transform: "rotate(72.8774 347.517 83.8674)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.829,
    cy: 113.899,
    r: 3,
    transform: "rotate(72.8774 346.829 113.899)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.062,
    cy: 112.832,
    r: 2.3323,
    transform: "rotate(95.5075 299.062 112.832)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.344,
    cy: 120.659,
    r: 1.03658,
    transform: "rotate(95.5075 280.344 120.659)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.849,
    cy: 140.832,
    r: 0.777432,
    transform: "rotate(95.5075 270.849 140.832)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.289,
    cy: 124.966,
    r: 1.29572,
    transform: "rotate(95.5075 295.289 124.966)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.97,
    cy: 139.195,
    r: 1.55486,
    transform: "rotate(95.5075 288.97 139.195)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.821,
    cy: 88.5604,
    r: 1.60929,
    transform: "rotate(145.243 242.821 88.5604)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.353,
    cy: 82.195,
    r: 0.715238,
    transform: "rotate(145.243 230.353 82.195)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.497,
    cy: 86.1932,
    r: 0.536429,
    transform: "rotate(145.243 215.497 86.1932)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.245,
    cy: 74.2441,
    r: 0.894048,
    transform: "rotate(145.243 237.245 74.2441)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.44,
    cy: 95.0036,
    r: 1.07286,
    transform: "rotate(145.243 224.44 95.0036)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.293,
    cy: 61.7469,
    r: 1.60929,
    transform: "rotate(51.2081 122.293 61.7469)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.821,
    cy: 74.6345,
    r: 0.715238,
    transform: "rotate(51.2081 116.821 74.6345)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.854,
    cy: 89.1721,
    r: 0.536429,
    transform: "rotate(51.2081 121.854 89.1721)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.257,
    cy: 76.257,
    r: 0.894048,
    transform: "rotate(51.2081 126.257 76.257)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.508,
    cy: 82.5084,
    r: 1.07286,
    transform: "rotate(51.2081 134.508 82.5084)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_570_1256",
    x1: 181,
    y1: 261.941,
    x2: 181.001,
    y2: 749.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803987,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_570_1256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 362,
    height: 610,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/bg2.2f03b3269c4b18b93a0d8b83a94360eb.svg";
export { ForwardRef as ReactComponent };